import React from 'react'
import { registerPixel, MetaPixel } from './meta-pixel-loader'

// Polaris-wide Meta Pixel. PageView is fired by meta-pixel-loader.initPixel
// immediately after fbq init; Purchase is called explicitly from the
// confirmation page. SPA route-change PageViews are handled by Meta's own
// auto-tracking of history.pushState — verified in browser; adding an explicit
// useEffect-based hook would double-fire because Meta also tracks the same
// transition. Event union is narrowed so additional event types aren't
// accidentally added to the platform pixel — adding more is a deliberate design
// change, not an incidental call-site decision. InitiateCheckout was added
// deliberately to mirror the marketing-supplied destination-catalog scripts.
type PlatformEvent = 'Purchase' | 'InitiateCheckout'

export function usePlatformMetaPixel(metaPixelId: string | null | undefined): {
  track: <E extends PlatformEvent>(event: E, payload: MetaPixel.EventPayload<E>) => void
} {
  const store = React.useMemo(() => registerPixel(metaPixelId), [metaPixelId])
  return React.useSyncExternalStore(store.subscribe, store.getSnapshot, store.getServerSnapshot)
}
